import { mapGetters } from 'vuex';
import Pagination from '@/components/pagination/index.vue';
import AssetsService from '../service.js';
import Service from '@/service/index.js';

export default {
  components: {
    Pagination
  },
  data () {
    return {
      listShow: true,
      activeName: '0',
      pageType: '',
      total: 0,
      tableList: [],
      Assetslist: [],
      projectType: '1',
      projectTypeArr: [],
      projectSubTypeArr: [],
      subTypeObj: {},
      searchForm: {
        pageNum: 1,
        pageSize: 5,
        type: 0
      },
      assetsStatusArr: [
        { code: 0, value: '可用' },
        { code: 1, value: '审核中' },
        { code: 2, value: '交易中' },
        { code: 3, value: '已流转' },
        { code: 4, value: '已到期' }
      ] // 资产状态
    };
  },

  created () {
    Service.getSelectList('APPROVE_ASSETS_STATUS').then(({ code, data }) => {
      if (code === '0') {
        this.assetsStatusArr = data;
      }
    });
    this.getList();
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    handleClick () {
      this.searchForm.type = Number(this.activeName);
      this.pageNo = 1;
      this.getList();
    },
    getList (page) {
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 5;
      }
      AssetsService.pageBatchAssets(this.searchForm.pageSize, this.searchForm.pageNum).then(res => {
        if (res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
        } else {
          errorMessage(res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    // 详情
    goDetails (item) {
      this.$router.push({ path: '/person-center/resources-assets/resources-detail?id=' + item.id });
    },
    // 编辑
    goApply (e) {
      this.$router.push({ path: '/person-center/resources-assets/add?editorid=' + e.id });
    },
    // 资源资产登记
    addAssets (e) {
      this.$router.push({ path: '/person-center/resources-assets/add?asstesType=' + e });
    },
    changeType () {
      this.$router.push({ path: '/person-center/resources-assets/classification'});
    }
  }
};

